import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

import useIncludedItems from '../../hooks/useIncludedItems';
import CollapsibleList from './CollapsibleList';

export function WhatsIncludedSection({ id, title, iconName, items }) {
  return (
    <div className="WhatsIncludedSection font-16">
      <div className="flex flex-column flex-md-row gap-12 mb3 mb6-md">
        <Icon name={iconName} width="32px" height="32px" className="black-60" />
        <h6 className="font-16 md:font-24 xs:font-sans md:font-serif fw-medium">
          {title}
        </h6>
      </div>
      <CollapsibleList id={id} items={items} />
    </div>
  );
}

WhatsIncludedSection.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  iconName: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string)
};

WhatsIncludedSection.defaultProps = {
  items: []
};

export default function WhatsIncluded({ className }) {
  const includedItems = useIncludedItems();

  return (
    <div className={classnames('WhatsIncluded', className)}>
      <h4 className="font-24 lh-title mb6">What’s included</h4>
      <div className="flex flex-column gap-32">
        {includedItems.map(({ id, title, items, iconName }) => (
          <WhatsIncludedSection
            key={id}
            id={id}
            title={title}
            items={items}
            iconName={iconName}
          />
        ))}
      </div>
    </div>
  );
}

WhatsIncluded.propTypes = {
  className: PropTypes.string
};

WhatsIncluded.defaultProps = {
  className: null
};
